import React, { useState, useEffect, useContext, useRef, useCallback} from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import * as Constants from '../Shared/Constants.js'
import { EventEmitter } from "events";
import AIChat from '../AIChat/AIChat.js';
import MedboardPdf from '../MedboardPdf/MedboardPdf.jsx';
import '../Shared/Style.css';

const MultiItemAIChatPane = ({ globalContext }) => {

    const AppContext = globalContext;
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [visibleDetailsTab, setVisibleDetailsTab] = useState("aichat");
    const [autoCallOverviewFunction, setAutoCallOverviewFunction] = useState(false);
    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(AppContext.isMultiItemAIChatPaneOpen);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [componentKey, setComponentKey] = useState(0);
    const [showItemContextMenu, setShowItemContextMenu] = useState(false);
    const [selectedPDFTab, setSelectedPDFTab] = useState("main");
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [isDeletingFile, setIsDeletingFile] = useState(false);
    const [multiItemData, setMultiItemData] = useState([]);
    const [selectedPDFUrl, setSelectedPDFUrl] = useState(null);
    const [fullWidthPane, setFullWidthPane] = useState(false);

    const firstEmitter = new EventEmitter();


    
    // On parent change of the details pane status "restart" the popup
    useEffect(() => {

        setVisibleDetailsTab("aichat");

        if (AppContext.isMultiItemAIChatPaneOpen == true) {
            // Immediately activate popup, but wait a bit to trigger the open animation
            setItemDetailsPaneActive(true);
            setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
        }
        else {
            // Immediately do the hide effect but wait 300 to deactivate the popup
            setItemDetailsPaneOpenEffect(false);
            setTimeout(() => { setItemDetailsPaneActive(false); }, 300);
        }


        let selectedItemList = [];

        let originalList = null;
        let origin = null;

        if (AppContext.entityType == "compliance-regulatorydocuments" || AppContext.entityType == "compliance-standards") {
            origin = "cm";
            originalList = AppContext.data;
        }

        if (AppContext.entityType == "reference-manager") {
            origin = "rm";
            originalList = AppContext.references;
        }

        if (AppContext.entityType == "submissionqa") {
            origin = "qa";
            originalList = AppContext.data;
        }

        if (originalList) {

            // AppContext.selectedReferences is the same var for both cm and rm
            selectedItemList = originalList.filter(i => AppContext.selectedReferences.includes(i.Id)).map(item => {

                let hasPDF = null;
                let mediaPath = item.MediaPath;
                let mbri = null;



                if (origin == "cm")
                    mbri = item.MedboardResourceId;
                if (origin == "rm" && item.HasPDF == 1)
                    mbri = item.MedBoardResourceId;



                if (hasValue(mediaPath))
                    hasPDF = mediaPath;
                else
                    if(hasValue(mbri))
                        hasPDF = "/Umbraco/Api/SurveilanceAppraisal/LoadPdf?surveillanceItemId=" + mbri;

                // QA doesn't fit the mediaPath/mbri (single-id lookup) shape above — its own
                // PDF endpoint needs both the submission and the item's own id, and
                // FileUploadedOn (already on every row, same field the QA table's own PDF
                // column icon uses) is what stands in for rm's "HasPDF == 1" presence check.
                if (origin == "qa" && hasValue(item.FileUploadedOn))
                    hasPDF = "/umbraco/api/SubmissionQA/QAFilePdf?submissionId=" + item.SubmissionId + "&qaId=" + item.Id;

                return (
                    {
                        Id: item.Id,
                        Name: origin == "cm" ? item.Name : item.Title,
                        HasPDF: hasPDF
                    }
                )
            });
        }

        setMultiItemData(selectedItemList);


    }, [AppContext.isMultiItemAIChatPaneOpen]);



    const reinitialize = () => {
        setVisibleDetailsTab("aichat");
        setAutoCallOverviewFunction(false);
        setSelectedPDFTab("main");
        setIsUploadingFile(false);
        setIsDeletingFile(false);
        setIsSavingItem(false);
        setSelectedPDFUrl(null);
        setFullWidthPane(null);

        AppContext.setIsShowingDeleteConfirmation(false);
    }


    useEffect(() => {

        if (itemDetailsPaneActive)
            reinitialize();

    }, [itemDetailsPaneActive]);



    useEffect(() => {

        if(!itemDetailsPaneOpenEffect)
            setShowItemContextMenu(false);

    }, [itemDetailsPaneOpenEffect])






    
    const hasValue = (field) => {

        if (field != null && field != "")
            return true;

        return false;
    }




    const callbackMultiItemDataSelectPDF = (url) => {
        setSelectedPDFUrl(url);
        setFullWidthPane(true);
    }





    

    return (

        <>


            {itemDetailsPaneActive ?

                <div
                    style={{ height: "100vh", overflow: "auto" }}
                    className={`${fullWidthPane ? "slide-pane-full-width" : "slide-pane"} ${itemDetailsPaneOpenEffect ? "open" : ""}`}
                >
                    <div className="content">


                        <div style={{ flex: "1" }}>


                                <div style={{ display: "flex", flexDirection: "row" }}>


                                        {/* PDF PANE */}
                                        {/* PDF PANE */}
                                        {/* PDF PANE */}

                                        {hasValue(selectedPDFUrl) ? <>
                                            <div id="pdf-viewer" style={{ flex: 25, paddingRight: "10px", borderRight: "2px solid #f0f0f0", height: "96vh" }}>

                                                <div style={{ display: "flex", flexDirection: "row", width: "100%", marginBottom: "5px" }}>
                                                    <div style={{ flex: 1 }}>
                                                        <h3>PDF Viewer</h3>
                                                    </div>
                                                </div>

                                                

                                                {hasValue(selectedPDFUrl) ?
                                                    <div id="pdfviewerdiv" style={{ height: "100%", marginBottom: "30px" }}>
                                                        <MedboardPdf
                                                            updater={firstEmitter}
                                                            savedComments={[]}
                                                            url={selectedPDFUrl}
                                                            showHighlightsButton={false}
                                                            showAnnotationsButton={false}
                                                            containerHeight={"80vb"}
                                                        />
                                                    </div>
                                                    :
                                                    <div style={{ marginTop: "15px" }}>No pdf file found.</div>
                                                }


                                            </div>

                                        </> : null}


























                                        {/* FIELDS PANE */}
                                        {/* FIELDS PANE */}
                                        {/* FIELDS PANE */}

                                        <div id="fields-content" style={{ flex: 20, flexDirection: "column", paddingLeft: "10px", height: "96vh", overflowY: "auto", position: "relative", display: "flex" }}>

                                            <div id="multiple-contents" style={{ flex: 1, overflow: "auto", paddingRight: "15px", display: "flex", flexDirection: "column" }}>

                                                <div style={{ display: "flex", marginBottom: "10px" }}>

                                            <div style={{ flex: 1, marginRight: "20px" }}>
                                                <h3 style={{ display: 'inline-block', margin: 0, marginRight: '10px' }}>
                                                    AI Multiple PDFs Chat
                                                </h3>
                                            </div>

                                                    <div>
                                                        <button className="close-button" onClick={AppContext.closeMultiItemAIChatPane}>
                                                            <i className="fas fa-times"></i>
                                                        </button>
                                                    </div>
                                                    
                                                </div>



                                                {/* TABS */}
                                                {/* TABS */}
                                                {/* TABS */}


                                                <div
                                                    style={{
                                                        display: "flex",
                                                        width: "100%",
                                                        flexDirection: "row",
                                                        marginBottom: "15px"
                                                    }}
                                                >



                                                    <div
                                                        style={{
                                                            cursor: "pointer",
                                                            paddingBottom: "3px",
                                                            paddingLeft: "8px",
                                                            paddingRight: "8px",
                                                            ...(visibleDetailsTab == "aichat"
                                                                ? { borderBottom: "2px solid #00abff" }
                                                                : { borderBottom: "2px solid #f0f0f0" })
                                                        }}
                                                        onClick={() => { setAutoCallOverviewFunction(false); setVisibleDetailsTab("aichat"); } }
                                                    >
                                                        <img src="/assets/images/stars-stroke-rounded-solid.svg" className="ai-icon" style={{ width: "19px", marginTop: "-3px", marginRight: "5px" }} /> AI Tools
                                                    </div>





                                                    <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>
                                                </div>



                                                {/* CONTENT */}
                                                {/* CONTENT */}
                                                {/* CONTENT */}


                                                <div style={{ display: "flex", flexDirection: "column", flex: 1, justifyContent: "start", overflow: "auto" }}>



                                                
                                                    {/* AI CHAT */}
                                                    {/* ... */}
                                                    {/* this is always drawn but controlled with css display so it doesn't clear chat text on tab change */ }

                                                    <div style={{ marginBottom: "10px", flex: 1, display: visibleDetailsTab == "aichat" ? "block" : "none" }}>

                                                        <div id="aichat-pane" style={{ flex: 1, padding: "0px 10px", borderRight: "2px solid #f0f0f0", height: "100%" }}>

                                                    <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }} >
                                                                <AIChat
                                                                    key={componentKey}
                                                                    defaultAiTask={"multi-item-analysis"}
                                                                    entityType={AppContext.entityType}
                                                                    entityId={null}
                                                                    uniqueId={null}
                                                                    embeddedAIComponent={true}
                                                                    enableUserChat={true}
                                                                    multiItemData={multiItemData}
                                                                    callbackMultiItemDataSelectPDF={callbackMultiItemDataSelectPDF}
                                                                    /* AIChat.js always appends "&items=...&sessionId=..." (see its own
                                                                       aiSrReportAPIUrl precedent, which ends in "?" for the same reason) —
                                                                       this override needs a trailing "?" too, or the concatenation produces
                                                                       an unroutable "QAMultiChat&items=..." with no "?" anywhere in it. */
                                                                    multiItemChatApiUrl={AppContext.entityType == "submissionqa" ? "/umbraco/api/SubmissionQA/QAMultiChat?" : undefined}
                                                                />

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>


                                            </div>






                                        </div>



                                    </div>


                        </div>

                    </div>
                </div>

            : null}



        </>
    );
};














export default MultiItemAIChatPane;